export default defineNuxtRouteMiddleware((to) => {
  if (!to.path.startsWith('/tests')) {
    return;
  }

  const testId = to.params.slug;

  if (isNaN(Number(testId))) {
    return navigateTo('/');
  }
});
